"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.wait = void 0;
var React = __importStar(require("react"));
var widget_1 = require("../basics/widget");
var options_1 = require("../basics/options");
/**
 * Don't use directly, use the [[wait]] function instead.
 * @todo maybe change it to `React.FunctionComponent` and hooks, since currently it does not use its state.
 */
var Wait = /** @class */ (function (_super) {
    __extends(Wait, _super);
    function Wait(props, context) {
        return _super.call(this, props, context) || this;
    }
    Wait.prototype.on_new_input = function (new_s) {
        var _this = this;
        if (this.timer == undefined) {
            this.timer = window.setTimeout(function () {
                if (_this.timer != undefined) {
                    _this.timer = undefined;
                    _this.props.on_done(new_s());
                }
            }, this.props.milliseconds);
        }
    };
    /** Note: new_props will keep getting ignored if there is a timer already running */
    Wait.prototype.componentWillReceiveProps = function (new_props) {
        // does not cancel current timer here
        this.on_new_input(new_props.input);
    };
    Wait.prototype.componentDidMount = function () {
        this.on_new_input(this.props.input);
    };
    Wait.prototype.componentWillUnmount = function () {
        window.clearTimeout(this.timer); /* cancel if there is a timer */
        this.timer = undefined;
    };
    Wait.prototype.render = function () {
        return this.timer ?
            React.createElement(React.Fragment, { key: (0, options_1.option)("key", this.props.options) })
            : null;
    };
    return Wait;
}(React.Component));
/**
 * `wait` builds a widget that waits a given number of `milliseconds` and then yields the lazy inputted value of type `io`.
 *
 *  Only after the given time passes, the lazy input is **computed** and passed to the output.
 *
 *
 * @typeparam io Both the input type and the output type of this IOwidget.
 * @param milliseconds The time to wait until yielding the output
 * @param options general widget options
 */
var wait = function (milliseconds, options) {
    return function (input) { return (0, widget_1.fromJSX)(function (on_done) {
        return React.createElement(Wait, { on_done: on_done, input: input, milliseconds: milliseconds, options: options });
    }); };
};
exports.wait = wait;
